import { categoryEnum } from "../enums/category.enum";
import { CustomerRiskStatusEnum } from "../enums/risk.enum";
import { ConditionField, CustomerAcceptance } from "../enums/review-workflow.enum";
import { ConditionOption, StepCondition } from "../interfaces/review-workflow.interface";

/** Array order is the order "Add condition" hands out options. */
export const CONDITION_OPTIONS: ConditionOption[] = [
  {
    field: ConditionField.RISK_ASSESSMENT,
    value: CustomerRiskStatusEnum.UNKNOWN,
    labelKey: "review-workflow.Condition_option_risk_unknown"
  },
  {
    field: ConditionField.RISK_ASSESSMENT,
    value: CustomerRiskStatusEnum.STANDARD,
    labelKey: "review-workflow.Condition_option_risk_standard"
  },
  { field: ConditionField.RISK_ASSESSMENT, value: CustomerRiskStatusEnum.HIGH, labelKey: "review-workflow.Condition_option_risk_high" },
  { field: ConditionField.CUSTOMER_ACCEPTANCE, value: CustomerAcceptance.ACCEPTED, labelKey: "review-workflow.Condition_option_accepted" },
  {
    field: ConditionField.CUSTOMER_ACCEPTANCE,
    value: CustomerAcceptance.NOT_ACCEPTED,
    labelKey: "review-workflow.Condition_option_not_accepted"
  }
];

export const CONDITION_CATEGORIES: readonly string[] = [
  categoryEnum.customerAcceptanceProcedure,
  categoryEnum.customerAcceptanceProcedureLight
];

const CONDITION_OPPOSITES: Record<string, string> = {
  [CustomerAcceptance.ACCEPTED]: CustomerAcceptance.NOT_ACCEPTED,
  [CustomerAcceptance.NOT_ACCEPTED]: CustomerAcceptance.ACCEPTED
};

export function availableConditionOptions(hasCustomerAcceptance: boolean, inUseValue?: string): ConditionOption[] {
  return CONDITION_OPTIONS.filter(
    option => hasCustomerAcceptance || option.field !== ConditionField.CUSTOMER_ACCEPTANCE || option.value === inUseValue
  );
}

export function isConditionValueBlocked(value: string, otherValues: readonly string[]): boolean {
  return otherValues.includes(value) || otherValues.includes(CONDITION_OPPOSITES[value]);
}

export function keepAvailableConditions(conditions: StepCondition[], hasCustomerAcceptance: boolean): StepCondition[] {
  const options = availableConditionOptions(hasCustomerAcceptance);
  return conditions.filter(condition => options.some(option => option.field === condition.field && option.value === condition.value));
}
